import {_MCP,
        UPDATE_PREV_SUCC_STEP, 
        RESET_CONFIGURATION, 
        PURCHASE_SUCCESS, PURCHASE_SENT,
        PREAUTH_SENT, PREAUTH_SUCCESS,
        PREAUTH_COMPLETION_SENT, PREAUTH_COMPLETION_SUCCESS,
        GETRATE_SENT, GETRATE_SUCCESS,
        PURCHASE_CORRECTION_SENT, PURCHASE_CORRECTION_SUCCESS,
        REFUND_SENT, REFUND_SUCCESS,
        INDEPENDENT_REFUND_SENT, INDEPENDENT_REFUND_SUCCESS,
        PURCHASE_WITH_VAULT_SENT, PURCHASE_WITH_VAULT_SUCCESS, PURCHASE_WITH_VAULT_FAIL,
        PREAUTH_WITH_VAULT_SENT, PREAUTH_WITH_VAULT_SUCCESS,
        INDREFUND_WITH_VAULT_SENT, INDREFUND_WITH_VAULT_SUCCESS,
        PURCHASE_3DS_SENT, PURCHASE_3DS_SUCCESS,
        PURCHASE_3DS_VAULT_SENT, PURCHASE_3DS_VAULT_SUCCESS,
        PREAUTH_3DS_SENT, PREAUTH_3DS_SUCCESS,
        PREAUTH_3DS_VAULT_SENT, PREAUTH_3DS_VAULT_SUCCESS,
        UPDATE_STORE_ID,
        UPDATE_PAN,
        UPDATE_ORDER_ID,
        UPDATE_EXPDATE,
        UPDATE_CURRENCY,
        UPDATE_API_TOKEN,
        UPDATE_AMOUNT,
        UPDATE_TXN_NUMBER,
        UPDATE_MCP_RATE_TOKEN,
        CLEAR_HISTORY,
        UPDATE_ON_EDIT_ID
    } from '../../actions/types'

const initialState = {
    prevSuccStep: 0, // the id of the most recent successful transaction (step)

    getRateResponse: "No request has been made.",
    purchaseResponse: "No request has been made.",
    preAuthResponse: "No request has been made.",
    preAuthCompResponse: "No request has been made.",
    purchaseCorrectionResponse: "No request has been made.",
    refundResponse: "No request has been made.",
    independentRefundResponse: "No request has been made.",
    purchaseWithVaultResponse: "No request has been made.",
    preAuthWithVaultResponse: "No request has been made.",
    indRefundWithVaultResponse: "No request has been made.",
    purchase3dsResponse: "No request has been made.",
    purchase3dsVaultResponse: "No request has been made.",
    preAuth3dsResponse: "No request has been made.",
    preAuth3dsVaultResponse: "No request has been made.",

    loading: false,
    history: [],
    mcpErrorCode: 0,

    getRateSuccess: false,
    purchaseSuccess: false,
    preAuthSuccess: false,
    preAuthCompSuccess: false,
    purchaseCorrectionSuccess: false,
    refundSuccess: false,
    independentRefundSuccess: false,
    purchaseWithVaultSuccess: false,
    preAuthWithVaultSuccess: false,
    indRefundWithVaultSuccess: false,
    purchase3dsSuccess: false,
    purchase3dsVaultSuccess: false,
    preAuth3dsSuccess: false,
    preAuth3dsVaultSuccess: false,

    config: {
        storeId: "store5", //monca02932
        apiToken: "yesguy", //CG8kYzGgzVU5z23irgMx
        orderId: "Test123456789",
        pan: "4242424242424242", //4606633870436092
        expdate: "2310",
        amount: "1.00",
        currency: "840",
        txnNumber: "none",
        mcpRateToken: "P1538681661706745",
        onEditId: 'none',
        eci: '7',
        cavv: 'AAABBJg0VhI0VniQEjRWAAAAAAA',
    }
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _MCP) {
        switch(action.type) {
            case UPDATE_PREV_SUCC_STEP:
                return { ...state, prevSuccStep: action.payload }

            case UPDATE_AMOUNT:
                return { ...state, config: { ...state.config, amount: action.payload }}
            case UPDATE_API_TOKEN:
                return { ...state, config: { ...state.config, apiToken: action.payload }}
            case UPDATE_CURRENCY:
                return { ...state, config: { ...state.config, currency: action.payload }}
            case UPDATE_EXPDATE:
                return { ...state, config: { ...state.config, expdate: action.payload }}
            case UPDATE_ORDER_ID:
                return { ...state, config: { ...state.config, orderId: action.payload }}
            case UPDATE_PAN:
                return { ...state, config: { ...state.config, pan: action.payload }}
            case UPDATE_STORE_ID:
                return { ...state, config: { ...state.config, storeId: action.payload }}
            case UPDATE_TXN_NUMBER:
                return { ...state, config: { ...state.config, txnNumber: action.payload }}
            case UPDATE_MCP_RATE_TOKEN:
                return { ...state, config: { ...state.config, mcpRateToken: action.payload }}
            case UPDATE_ON_EDIT_ID:
                return { ...state, config: { ...state.config, onEditId: action.payload }}
    

            case GETRATE_SENT:
                return { ...state, loading: true, getRateSuccess: false, history: [] }
            case GETRATE_SUCCESS:
                return { ...state, history: [3], getRateResponse: action.payload, loading: false, getRateSuccess: true }

            case PURCHASE_SENT:
                return { ...state, loading: true, purchaseSuccess: false, history: [] }
            case PURCHASE_SUCCESS:
                return { ...state, history: [4], purchaseResponse: action.payload, loading: false, purchaseSuccess: true }

            case PURCHASE_3DS_SENT:
                return { ...state, loading: true, purchase3dsSuccess: false, history: [] }
            case PURCHASE_3DS_SUCCESS:
                return { ...state, history: [5], purchase3dsResponse: action.payload, loading: false, purchase3dsSuccess: true }

            case PURCHASE_WITH_VAULT_SENT:
                return { ...state, loading: true, purchaseWithVaultSuccess: false, history: []  }
            case PURCHASE_WITH_VAULT_SUCCESS:
                return { ...state, history: [6], purchaseWithVaultResponse: action.payload, loading: false, purchaseWithVaultSuccess: true }
            case PURCHASE_WITH_VAULT_FAIL:
                return { ...state, purchaseWithVaultResponse: action.payload, loading: false, mcpErrorCode: action.mcpErrorCode}

            case PURCHASE_3DS_VAULT_SENT:
                return { ...state, loading: true, purchase3dsVaultSuccess: false, history: [] }
            case PURCHASE_3DS_VAULT_SUCCESS:
                return { ...state, history: [7], purchase3dsVaultResponse: action.payload, loading: false, purchase3dsVaultSuccess: true }

            case PREAUTH_SENT:
                return { ...state, loading: true, preAuthSuccess: false, history: [] }
            case PREAUTH_SUCCESS:
                return { ...state, history: [8], preAuthResponse: action.payload, loading: false, preAuthSuccess: true, preAuthCompSuccess: false, preAuthCompResponse: "No request has been made." }

            case PREAUTH_3DS_SENT:
                return { ...state, loading: true, preAuth3dsSuccess: false, history: [] }
            case PREAUTH_3DS_SUCCESS:
                return { ...state, history: [9], preAuth3dsResponse: action.payload, loading: false, preAuth3dsSuccess: true }

            case PREAUTH_WITH_VAULT_SENT:
                return { ...state, loading: true, preAuthWithVaultSuccess: false, history: []  }
            case PREAUTH_WITH_VAULT_SUCCESS:
                return { ...state, history: [10], preAuthWithVaultResponse: action.payload, loading: false, preAuthWithVaultSuccess: true }

            case PREAUTH_3DS_VAULT_SENT:
                return { ...state, loading: true, preAuth3dsVaultSuccess: false, history: [] }
            case PREAUTH_3DS_VAULT_SUCCESS:
                return { ...state, history: [11], preAuth3dsVaultResponse: action.payload, loading: false, preAuth3dsVaultSuccess: true }

            case PREAUTH_COMPLETION_SENT:
                return { ...state, loading: true, preAuthCompSuccess: false }
            case PREAUTH_COMPLETION_SUCCESS:
                return { ...state, history: [ ...state.history, 12], preAuthCompResponse: action.payload, loading: false, preAuthCompSuccess: true }

            case PURCHASE_CORRECTION_SENT:
                return { ...state, loading: true, purchaseCorrectionSuccess: false }
            case PURCHASE_CORRECTION_SUCCESS:
                return { ...state, history: [ ...state.history, 13], purchaseCorrectionResponse: action.payload, loading: false, purchaseCorrectionSuccess: true }

            case REFUND_SENT:
                return { ...state, loading: true, refundSuccess: false }
            case REFUND_SUCCESS:
                return { ...state, history: [ ...state.history, 14], refundResponse: action.payload, loading: false, refundSuccess: true }

            case INDEPENDENT_REFUND_SENT:
                return { ...state, loading: true, independentRefundSuccess: false , history: []}
            case INDEPENDENT_REFUND_SUCCESS:
                return { ...state, history: [15], independentRefundResponse: action.payload, loading: false, independentRefundSuccess: true }

            case INDREFUND_WITH_VAULT_SENT:
                return { ...state, loading: true, indRefundWithVaultSuccess: false }
            case INDREFUND_WITH_VAULT_SUCCESS:
                return { ...state, history: [ ...state.history, 16], indRefundWithVaultResponse: action.payload, loading: false, indRefundWithVaultSuccess: true }

            case CLEAR_HISTORY:
                return { ...state, history: [],
                    getRateResponse: "No request has been made.",
                    purchaseResponse: "No request has been made.",
                    preAuthResponse: "No request has been made.",
                    preAuthCompResponse: "No request has been made.",
                    purchaseCorrectionResponse: "No request has been made.",
                    refundResponse: "No request has been made.",
                    independentRefundResponse: "No request has been made.",
                    purchaseWithVaultResponse: "No request has been made.",
                    preAuthWithVaultResponse: "No request has been made.",
                    indRefundWithVaultResponse: "No request has been made.",
                    purchase3dsResponse: "No request has been made.",
                    purchase3dsVaultResponse: "No request has been made.",
                    preAuth3dsResponse: "No request has been made.",
                    preAuth3dsVaultResponse: "No request has been made.",

                    getRateSuccess: false,
                    purchaseSuccess: false,
                    preAuthSuccess: false,
                    preAuthCompSuccess: false,
                    purchaseCorrectionSuccess: false,
                    refundSuccess: false,
                    independentRefundSuccess: false,
                    purchaseWithVaultSuccess: false,
                    preAuthWithVaultSuccess: false,
                    indRefundWithVaultSuccess: false,
                    purchase3dsSuccess: false,
                    purchase3dsVaultSuccess: false,
                    preAuth3dsSuccess: false,
                    preAuth3dsVaultSuccess: false,
                }


            case RESET_CONFIGURATION:
                return { ...state, config: initialState.config }
    
    
            default:
                return state
        }
    }
    else {
        return state
    }
}